import React from "react";
import { Divider } from "digiwash-components";
import SelectableCard from "../../components/SelectableCard";
import CartItem from "../../components/CartItem";
import { FormattedCartItem } from "../../ducks/cart/cart-types";

export default OrderListInBasket;

interface PropTypes {
  items?: FormattedCartItem[];
  readonly?: boolean;
}

function OrderListInBasket(props: PropTypes) {
  let list = [];

  if (props.items) {
    list.push(
      <SelectableCard
        title="سفارش خود را ثبت کنید!"
        desc="برای ثبت سفارش لطفا اقلام خود را ابتدا انتخاب کنید."
        selected
        readonly
      />
    );
  }
  if (props.items?.length > 0) {
    list = [];
    props.items.forEach((data, index) => {
      list.push(
        <React.Fragment key={index}>
          <CartItem data={data} />
          <Divider size="l" />
        </React.Fragment>
      );
    });
  }

  if (list.length > 0) {
    return (
      <>
        <Divider size="l" />
        {list}
      </>
    );
  } else {
    return null;
  }
}
